<header>
    <nav class="navbar">
        <div *ngIf="loginService.isUserLoggedIn; then userLoggedIn else userNotLoggedIn"></div>
        <ng-template #userNotLoggedIn>
            <ng-container *ngIf="!loginService.isUserSignedUp">
                <div class="container-fluid">
                    <ul class="nav navbar-nav navbar-right">
                        <li>
                            <button class="btns btn-add" (click)="onRedirect('login/signup')">Sign Up</button>
                            <button class="btns btn-add" (click)="onRedirect('login')">LogIn</button>
                        </li>
                    </ul>
                </div>
            </ng-container>
        </ng-template>
        <ng-template #userLoggedIn>
            <div class="container-fluid">
                <div id="navbar-header" class="navbar-header">
                    <div>{{headerName}}</div>
                </div>
                <ul class="nav navbar-nav navbar-right">
                    <li>
                        <button class="btns btn-add" (click)="showInbox()">Inbox</button>
                        <button class="btns btn-add" (click)="onLogout()">Logout</button>
                    </li>
                </ul>
            </div>
        </ng-template>
    </nav>
</header>